import React from 'react'

interface IProps {
  children: React.ReactNode
}

export const SkPageEditColCenter = (props: IProps) => {
  return <div className="skPageEditCol scroll-design flex-auto bg-gray-100">{props.children}</div>
}
